import type { ReactNode } from 'react';
import { Skeleton } from '@/shared/ui';

type Props = {
  /** メッセージ左肩のアバター（事業チャットはフォルダ、汎用チャットはCpuChip等） */
  avatar: ReactNode;
};

/** AI 応答生成中の共通スケルトン（アバター + テキスト3行のスケルトン）。 */
export const LoadingMessageLayout = ({ avatar }: Props) => (
  <div className="flex flex-col gap-2">
    {avatar}
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  </div>
);
